import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {ToastService} from "../../lib/services/toast/toast.service";

@Component({
  selector: 'app-phrase-img-success',
  templateUrl: './phrase-img-success.component.html',
  styleUrls: ['./phrase-img-success.component.scss']
})
export class PhraseImgSuccessComponent {
  modalRef!: NgbModalRef;
  isDateProgrammed: boolean = true;
  loading: boolean = false
  isSpid: boolean = false
  @Output() closeModalEvent: EventEmitter<boolean> = new EventEmitter<boolean>()
  @Input() successRequest: any;
  isEnabled: boolean= true


  constructor(
      private toastService : ToastService
  ) {
  }
  ngOnInit() {
  }


  closeModal() {
    this.closeModalEvent.emit();
  }

}
